import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Job from "../../common/job/Job";
import "./recent_jobs.css";
import { ReactComponent as Button1 } from "../../../images/button (1).svg";
import { ReactComponent as Button2 } from "../../../images/button (2).svg";
import { ReactComponent as Button3 } from "../../../images/button (3).svg";
import { ReactComponent as Button4 } from "../../../images/button (4).svg";
import { ReactComponent as Button5 } from "../../../images/button (5).svg";
import { ReactComponent as Button6 } from "../../../images/button (6).svg";
import { ReactComponent as Button7 } from "../../../images/button (7).svg";
import jobsConfig from "../../../configs/jobDepartments/jobDepartments.json";
import Config from "../../../configs";

const baseUrl = `${Config.gatewayBaseUrl}/api/v2/platform-gateway`;

const RecentJobs = () => {
  const [jobsList, setJobsList] = useState([]);
  const departments = jobsConfig.departmentInCareerPage;
  const departmentMap =
    jobsConfig.departmentInCareerPage__parentDepartmentInUc;
  const inverseDepartmentMap =
    jobsConfig.parentDepartmentInUc__departmentInCareerPage;
  useEffect(() => {
    axios.post(`${baseUrl}/getAllJobs`).then((response) => {
      setJobsList(response.data.jobs);
    });
  }, []);
  const countDepartmentJobs = (index) => {
    return jobsList
      ? jobsList.filter(
          (job) =>
            inverseDepartmentMap[job.parent_department] === departments[index]
        ).length
      : 0;
  };

  const getRelevantJobsForHomePage = () => {
    let jobs;
    const enggJobs = [];
    const restJobs = [];
    const totalJobsCount = 6;
    const enggJobsCount = 3;
    if (jobsList) {
      for (let index = 0; index < jobsList.length; index++) {
        const job = jobsList[index];
        if (
          departmentMap["Engineering & Data"].includes(job.parent_department)
        ) {
          enggJobs.push(job);
        } else if (restJobs.length < totalJobsCount) {
          restJobs.push(job);
        }
      }
      const enggJobsLength =
        enggJobsCount > enggJobs.length ? enggJobs.length : enggJobsCount;
      const remainingJobsCount = totalJobsCount - enggJobsLength;
      jobs = [
        ...enggJobs.slice(0, enggJobsCount),
        ...restJobs.slice(0, remainingJobsCount),
      ];
    }
    return jobs;
  };

  return (
    <div className="recent-jobs" id="recent-jobs">
      <div className="recent-jobs-header">
        <div className="recent-jobs-heading">
          <h1>Open positions</h1>
        </div>
      </div>
      <div className="body">
        <div className="recent-jobs-list">
          <div className="list-header">
            <h3 className="heading">Recent openings</h3>
            <Link to="/jobs" className="view-all">
              View all openings &nbsp; <i className="fa fa-chevron-right"></i>
            </Link>
          </div>
          <div className="list-body">
            {getRelevantJobsForHomePage().map((job, index) => (
              <Link
                key={index}
                to={`/jobDetail?id=${job.job_id}`}
                className={`box-${
                  departments.indexOf(
                    inverseDepartmentMap[job.parent_department]
                  ) + 1
                }`}
              >
                <Job
                  key={index}
                  role={job.job_title}
                  department={job.parent_department}
                  locations={job.location_city}
                />
              </Link>
            ))}
          </div>
        </div>
        <div className="department-jobs">
          <div className="section-header">
            <h3 className="heading">Departments</h3>
          </div>
          <div className="section-body row">
            <div className="col-12 col-md-4">
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[0])}`}
                className="department-box box-1"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[0]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(0) > 0 &&
                      `${countDepartmentJobs(0)} openings`}
                    <Button1 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[1])}`}
                className="department-box box-2"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[1]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(1) > 0 &&
                      `${countDepartmentJobs(1)} openings`}
                    <Button2 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-md-4">
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[2])}`}
                className="department-box box-3"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[2]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(2) > 0 &&
                      `${countDepartmentJobs(2)} openings`}
                    <Button3 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[3])}`}
                className="department-box box-4"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[3]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(3) > 0 &&
                      `${countDepartmentJobs(3)} openings`}
                    <Button4 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-md-4">
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[4])}`}
                className="department-box box-5"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[4]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(4) > 0 &&
                      `${countDepartmentJobs(4)} openings`}
                    <Button5 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[5])}`}
                className="department-box box-6"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[5]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(5) > 0 &&
                      `${countDepartmentJobs(5)} openings`}
                    <Button6 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
              <Link
                to={`/jobs?department=${encodeURIComponent(departments[6])}`}
                className="department-box box-7"
              >
                <div className="wrapper">
                  <h5 className="title">{departments[6]}</h5>
                  <div className="subtitle">
                    {countDepartmentJobs(6) > 0 &&
                      `${countDepartmentJobs(6)} openings`}
                    <Button7 className="arrow-button" />
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentJobs;
